<template>
  <div style="width:100%;float:left;">
    <CCard>
      <CCardBody>
        <div class="col-md-4 float-left">
          <label>Status Filter</label>
          <select v-model="holdFilter" class="form-control">
            <option value="all">All Waiting On Customer</option>
            <option value="credit_hold">Credit Hold Only</option>
            <option value="not_on_hold">Not On Credit Hold</option>
          </select>
        </div>
        <div class="col-md-8 float-left text-right pt-4">
          <CButton size="sm" color="success" @click="getData()">Refresh</CButton>
          <CButton size="sm" color="info" class="ml-2" :disabled="!data || !data.length" @click="downloadCsv()">Download CSV</CButton>
        </div>
        <div class="all float-left mt-3">
          <CDataTable
            v-if="data"
            :items="data"
            :fields="fields"
            column-filter
            table-filter
            sorter
            hover
            @row-clicked="rowClicked"
          >
            <template #credit_hold="{item}">
              <td>
                <CBadge :color="item.customer_on_hold ? 'danger' : 'secondary'">
                  {{ item.customer_on_hold ? 'Yes' : 'No' }}
                </CBadge>
              </td>
            </template>
          </CDataTable>
          <small-loader v-else-if="loading"></small-loader>
        </div>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
var methods = {}

methods.getData = function () {
  this.loading = true
  const postData = {
    hold_filter: this.holdFilter
  }

  axios.post(this.$apiAdress + '/api/reports/getWaitingOnCustomerReport?token=' + localStorage.getItem('api_token'), postData).then((response) => {
    this.data = response.data
    this.loading = false
  }).catch(() => {
    this.loading = false
  })
}

methods.rowClicked = function (item) {
  this.$router.push('/order/' + item.order_id + '/' + item.order_group_id)
}

methods.downloadCsv = function () {
  if (!this.data || !this.data.length) return

  const headers = [
    'Log #',
    'Customer',
    'PO #',
    'Rep',
    'CSR',
    'Status',
    'Credit Hold',
    'Reason',
    'Ship Date',
    'Created'
  ]

  const escapeCsv = function (value) {
    const str = value === null || value === undefined ? '' : String(value)
    if (/[",\n]/.test(str)) {
      return '"' + str.replace(/"/g, '""') + '"'
    }
    return str
  }

  const rows = this.data.map((item) => ([
    item.as400_log_number,
    item.customer_name,
    item.po_number,
    item.rep_name,
    item.csr_name,
    item.as400_status,
    item.customer_on_hold ? 'Yes' : 'No',
    item.hold_reason,
    item.ship_date,
    item.created_at
  ]))

  const csv = [headers]
    .concat(rows)
    .map((row) => row.map(escapeCsv).join(','))
    .join('\n')

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  const dateSuffix = new Date().toISOString().slice(0, 10)
  link.href = url
  link.setAttribute('download', 'waiting_on_customer_report_' + this.holdFilter + '_' + dateSuffix + '.csv')
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

export default {
  name: 'WaitingOnCustomerReport',
  data () {
    return {
      data: null,
      loading: false,
      holdFilter: 'all',
      fields: [
        { key: 'as400_log_number', label: 'Log #' },
        { key: 'customer_name', label: 'Customer' },
        { key: 'po_number', label: 'PO #' },
        { key: 'rep_name', label: 'Rep' },
        { key: 'csr_name', label: 'CSR' },
        { key: 'as400_status', label: 'Status' },
        { key: 'credit_hold', label: 'Credit Hold' },
        { key: 'hold_reason', label: 'Reason' },
        { key: 'ship_date', label: 'Ship Date' },
        { key: 'created_at', label: 'Created' }
      ]
    }
  },
  mounted () {
    this.getData()
  },
  methods: methods
}
</script>

<style scoped></style>
